

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_FloatingHelper";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_FloatingHelper__root","closeButton":"wds_1_209_0_FloatingHelper__closeButton","innerContent":"wds_1_209_0_FloatingHelper__innerContent"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"closeButtonPadding":"6px"}; 
export var vars = {}; 




